<!-- 话务分析 -->
<template>
  <div class="traffic" style="">
    <div style="height:50%;text-align: center;overflow:hidden">
      <div class="traffic_big">
          <div class="circle">
            <p :class="classObject(callInCount)">{{callInCount}}<span>通</span></p>
          </div>
          <div class="font_name">
            <p>呼入总量</p>
          </div>
      </div>
      <div class="traffic_big">
          <div class="circle">
            <p :class="classObject(calloutCount)">{{calloutCount}}<span>通</span></p>
          </div>
          <div class="font_name">
             <p>呼出总量</p>
          </div>
      </div>
      <div class="traffic_big">
          <div class="circle">
            <p :class="classObject(calloutAnswer)">{{calloutAnswer}}<span>通</span></p>
          </div>
          <div class="font_name">
            <p>呼出接通量</p>
          </div>
      </div>
      <div class="traffic_big">
          <div class="circle">
            <p :class="classObject(calloutAnswerAverage)"> {{calloutAnswerAverage}}<span>%</span></p>
          </div>
          <div class="font_name">
            <p>呼出接通率</p>
          </div>
      </div>
      <div class="traffic_big">
          <div class="circle">
           <p :class="classObject(turnSatisfied)">{{turnSatisfied}}<span>通</span></p>
          </div>
          <div class="font_name">
             <p>转满意度</p>
          </div>
      </div>
    </div>
    <div style="height:50%;text-align: center;overflow:hidden">
      <div class="traffic_big">
          <div class="circle">
            <p  :class="classObject(turnPeople)">{{turnPeople}}<span>通</span></p>

          </div>
          <div class="font_name">
            <p>转人工量</p>
          </div>
        <div class="font_name">
          <p>转人工量</p>
        </div>
      </div>
      <div class="traffic_big">
          <div class="circle">
            <p :class="classObject(turnPeopleAnswer)">{{turnPeopleAnswer}}<span>通</span></p>
          </div>
          <div class="font_name">
            <p>转人工接通量</p>
          </div>
      </div>
      <div class="traffic_big">
          <div class="circle">
           <p :class="classObject(turnPeopleAnswerAverage)">{{turnPeopleAnswerAverage}}<span>%</span></p>
          </div>
          <div class="font_name">
             <p>转人工接通率</p>

          </div>
      </div>
      <div class="traffic_big">
          <div class="circle">
             <p :class="classObject(callDurationAverage)" >{{callDurationAverage}}<span>秒</span></p>

          </div>
          <div class="font_name">
            <p>平均通话时长</p>
          </div>
      </div>
      <div class="traffic_big">
          <div class="circle">
           <p :class="classObject(lineUpAverage)" >{{lineUpAverage}}<span>秒</span></p>
          </div>
          <div class="font_name">
            <p>平均排队时长</p>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "trafficAnalysis",
    data() {
      return {
        // 话务分析
        callInCount: '3', //呼入总量
        calloutCount: '999999', //呼出总量
        calloutAnswer: '76', //呼出接通量
        calloutAnswerAverage: '62.5', //呼出接通率
        turnPeople: '1680', //转人工量
        turnSatisfied: '689', //转满意度
        turnPeopleAnswer: '12104', //转人工接通量
        callDurationAverage: '0.7', //平均通话时长
        turnPeopleAnswerAverage: '12.65', //转人工接通率
        lineUpAverage: '8.35', //平均排队时长
        timeFlag: '',
      }
    },
    created() {
      this.trafficAnalysis();
      this.timeFlag = setInterval(this.trafficAnalysis, 5000);
    },
    methods: {
        // 话务分析
      trafficAnalysis() {
        let that = this;
        let param = {
          journalType: null,
          menuId: null
        };

        this.$http.post("bigScreen/toCallAnalysisIndex.json", param).then(function (res) {
          let result = res.data.flag;
          if (result != "666") {
            that.$Modal.info({
              title: '提示',
              content: res.data.msg
            });
            return false;
          }
          that.callInCount = res.data.obj.callinCount; //呼入总量
          that.calloutCount = res.data.obj.calloutCount; //呼出总量
          that.calloutAnswer = res.data.obj.calloutAnswer; //呼出接通量
          that.calloutAnswerAverage = res.data.obj.calloutAnswerAverage; //呼出接通率
          that.turnPeople = res.data.obj.turnPeople; //转人工量
          that.turnSatisfied = res.data.obj.turnSatisfied; //转满意度
          that.turnPeopleAnswer = res.data.obj.turnPeopleAnswer; //转人工接通量
          that.callDurationAverage = res.data.obj.callDurationAverage; //平均通话时长
          that.turnPeopleAnswerAverage = res.data.obj.turnPeopleAnswerAverage; //转人工接通率
          that.lineUpAverage = res.data.obj.lineUpAverage; //平均排队时长
        });
      },

      classObject: function (font) {
        if (font === undefined) {
          font = "";
        }

        if (font.length == 1) {
          return {
            'one-font-class':true
          }
        }else if(font.length == 2){
          return {
            'two-font-class':true
          }
        }else if(font.length == 3){
          return {
            'three-font-class':true
          }
        }else if(font.length == 4){
          return {
            'four-font-class':true
          }
        }else if(font.length == 5){
          return {
            'five-font-class':true
          }
        }else if(font.length == 6){
          return {
            'six-font-class':true
          }
        }else if(font.length == 7){
          return {
            'seven-font-class':true
          }
        }else if(font.length == 8){
           return {
            'eight-font-class':true
          }
        }
      },


    },
    beforeDestroy() {
       if(this.timeFlag){
            clearInterval(this.timeFlag);
        }
        this.trafficAnalysis = null;
        this.classObject = null;
    },
    destroyed() {
        if(this.timeFlag){
            clearInterval(this.timeFlag);
          }
      },

  }
</script>
<style scoped lang="less">
@import "../../assets/css/daping.less";
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/trafficAnalysis.vue